//Localhost

// const API_URLS = {
//   CONTACT: "http://localhost/Safepro_Project/controllers/ContactController.php",
//   CAREER: "http://localhost/Safepro_Project/controllers/CareerController.php",
//   PARTNER: "http://localhost/Safepro_Project/controllers/PartnerController.php",
//   FACESENSE:
//     "http://localhost/Safepro_Project/controllers/CatalogController.php?CatalogName=safepro_facesense_EMAIL",
//   HOMEPAGE:
//     "http://localhost/Safepro_Project/controllers/CatalogController.php?CatalogName=Safepro_Company_products",
//   ADMETRICS:
//     "http://localhost/Safepro_Project/controllers/CatalogController.php?CatalogName=admetrics",
//   THERMOGRAPHY:
//     "http://localhost/Safepro_Project/controllers/CatalogController.php?CatalogName=thermography",
//   RETAILYTICS:
//     "http://localhost/Safepro_Project/controllers/CatalogController.php?CatalogName=RETAILYTICS",
//   DRIVE_ALERT:
//     "http://localhost/Safepro_Project/controllers/CatalogController.php?CatalogName=Drive_allert",
//   VIGILAR:
//     "http://localhost/Safepro_Project/controllers/CatalogController.php?CatalogName=Vigilar",
//   EDUMETRICS:
//     "http://localhost/Safepro_Project/controllers/CatalogController.php?CatalogName=Edumetrics",
//   ANPR: "http://localhost/Safepro_Project/controllers/CatalogController.php?CatalogName=ANPR",
//   EZPARKING:
//     "http://localhost/Safepro_Project/controllers/CatalogController.php?CatalogName=Ezparking",
//   VIDEO_ANALYTICS:
//     "http://localhost/Safepro_Project/controllers/CatalogController.php?CatalogName=VA_Catalog",
//   SAFETY_GEAR:
//     "http://localhost/Safepro_Project/controllers/CatalogController.php?CatalogName=VA_Catalog",
//   OBJECT_DETECTION:
//     "http://localhost/Safepro_Project/controllers/CatalogController.php?CatalogName=VA_Catalog",
//   CUSTOM_MADE:
//     "http://localhost/Safepro_Project/controllers/CatalogController.php?CatalogName=VA_Catalog",
//   PERIMETRION:
//     "http://localhost/Safepro_Project/controllers/CatalogController.php?CatalogName=Perimetrion",
//   OCTASENSE:
//     "http://localhost/Safepro_Project/controllers/CatalogController.php?CatalogName=Octasense",
//   DEMO: "http://localhost/Safepro_Project/controllers/CatalogController.php?CatalogName=",
// };

// export default API_URLS;

//Live - HTTPS

const API_URLS = {
  CONTACT:
    "https://safepro.tech/Safepro_Project/controllers/ContactController.php",
  CAREER:
    "https://safepro.tech/Safepro_Project/controllers/CareerController.php",
  PARTNER:
    "https://safepro.tech/Safepro_Project/controllers/PartnerController.php",
  FACESENSE:
    "https://safepro.tech/Safepro_Project/controllers/CatalogController.php?CatalogName=safepro_facesense_EMAIL",
  HOMEPAGE:
    "https://safepro.tech/Safepro_Project/controllers/CatalogController.php?CatalogName=Safepro_Company_products",
  ADMETRICS:
    "https://safepro.tech/Safepro_Project/controllers/CatalogController.php?CatalogName=admetrics",
  THERMOGRAPHY:
    "https://safepro.tech/Safepro_Project/controllers/CatalogController.php?CatalogName=thermography",
  RETAILYTICS:
    "https://safepro.tech/Safepro_Project/controllers/CatalogController.php?CatalogName=RETAILYTICS",
  DRIVE_ALERT:
    "https://safepro.tech/Safepro_Project/controllers/CatalogController.php?CatalogName=Drive_allert",
  VIGILAR:
    "https://safepro.tech/Safepro_Project/controllers/CatalogController.php?CatalogName=Vigilar",
  EDUMETRICS:
    "https://safepro.tech/Safepro_Project/controllers/CatalogController.php?CatalogName=Edumetrics",
  ANPR: "https://safepro.tech/Safepro_Project/controllers/CatalogController.php?CatalogName=ANPR",
  EZPARKING:
    "https://safepro.tech/Safepro_Project/controllers/CatalogController.php?CatalogName=Ezparking",
  VIDEO_ANALYTICS:
    "https://safepro.tech/Safepro_Project/controllers/CatalogController.php?CatalogName=VA_Catalog",
  SAFETY_GEAR:
    "https://safepro.tech/Safepro_Project/controllers/CatalogController.php?CatalogName=VA_Catalog",
  OBJECT_DETECTION:
    "https://safepro.tech/Safepro_Project/controllers/CatalogController.php?CatalogName=VA_Catalog",
  CUSTOM_MADE:
    "https://safepro.tech/Safepro_Project/controllers/CatalogController.php?CatalogName=VA_Catalog",
  PERIMETRION:
    "https://safepro.tech/Safepro_Project/controllers/CatalogController.php?CatalogName=Perimetrion",
  OCTASENSE:
    "https://safepro.tech/Safepro_Project/controllers/CatalogController.php?CatalogName=Octasense",
  DEMO: "https://safepro.tech/Safepro_Project/controllers/CatalogController.php?CatalogName=",
};

export default API_URLS;
